import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import AdminModal from "./AdminModal";

const AdminList = ({ items, resetState, pending }) => {
  
  const columns = [
    {
      name: <DataTableTitle text="ID" />,
      selector: (row) => row.id,
      sortable: true,
      style: {
        alignItems: 'flex-start',
      },
    },
    {
      name: <DataTableTitle text="Role" />,
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
      style: {
        alignItems: 'flex-start',
      },
    },
    {
      name: <DataTableTitle text="Permissions" />,
      selector: (row) => (
        <ul style={{ paddingLeft: '20px', margin: 0 }}>
          {row.permissions.map(permission => (
            <li key={permission.id} style={{ listStyleType: 'none' }}>{permission.name}</li>
          ))}
        </ul>
      ),
      sortable: true,
      wrap: true,
      style: {
        alignItems: 'flex-start',
      },
    },
    {
      name: <DataTableTitle text="User" />,
      selector: (row) => (
        <ul style={{ paddingLeft: '20px', margin: 0 }}>
          {row.users.map(item => (
            <li key={item.id} style={{ listStyleType: 'none' }}>{item.username}</li>
          ))}
        </ul>
      ),
      sortable: true,
      wrap: true,
      style: {
        alignItems: 'flex-start',
      },
    },
    {
      name: <DataTableTitle text="Operations" />,
      width: "15%",
      cell: (row) => (
        <div>
          <AdminModal create={false} data={row} resetState={resetState} />
        </div>
      ),
      style: {
        alignItems: 'flex-start',
      },
    },
  ]
  
  return (
    <PengaturanListLayout
      items={items}
      itemColumns={columns}
      // searchCategories={}
      pending={pending}
    />
  );
}

export default AdminList;